import { YI_CONTENT_ROOT_PATH } from './routes'

export function getYIContentUrlById (id: string) {
  return `${YI_CONTENT_ROOT_PATH}/${id}`
}
